export const GREEN_LEGEND_COLOR = '#becf41';
export const BLUE_GREY_BORDER_COLOR = '#d3dfe9';
export const LIGHT_BLUE_HEADER_BACKGROUND_COLOR = '#e6ecf3';
export const BLUE_HEADER_BACKGROUND_COLOR = '#c0d1df';
export const ORANGE_HEADER_COLOR = '#ffc000';
export const ORANGE_GREY_BORDER_COLOR = '#fce9ae';
export const LIGHT_GREEN_HEADER_COLOR = '#c6e0b4';
export const LIGHT_GREEN_GREY_BORDER_COLOR = '#ddfcc7';
export const BLUE_GREY_LEGEND_COLOR = '#ddebf7';
